import React from 'react';

const Photos: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <h1 className="text-2xl font-serif text-gray-900">Your Photos</h1>
      <p className="text-gray-500 mt-4">Photo gallery coming soon...</p>
    </div>
  );
};

export default Photos;